import { useThemeStore } from "@stores/theme.store";
import {
  getCurrentTahunAjaran,
  useReportCardStore,
} from "@stores/report-card.store";
import { Select } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { Spiner } from "@components/loaders/spiner";
import { FcFinePrint } from "react-icons/fc";
// moment.locale("id");

const getTahunAjaranOptions = () => {
  const currentStartYear = Number(getCurrentTahunAjaran().split("_")[0]);
  return Array.from({ length: 5 }, (_, i) => currentStartYear - i).map(
    (startYear) => ({
      value: `${startYear}_${startYear + 1}`,
      label: `${startYear}/${startYear + 1}`,
    })
  );
};

export const FinalReportCardPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const { semester, tahunAjaran, setSemester, setTahunAjaran } =
    useReportCardStore((state) => state);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending, isFetching } = useQuery({
    queryKey: [
      SchoolService.queries.GET_SCHOOL_STUDENT_RAPOR,
      nis,
      semester,
      tahunAjaran,
    ],
    queryFn: () => SchoolService.studentRapor({ nis, semester, tahunAjaran }),
  });

  const onOpenDetail = (data: any, marhalah: string) => {
    if (marhalah === "MTW" || marhalah === "mtw") {
      navigate(linkPage.FINAL_REPORT_CARD_MTW, { state: data });
    } else if (marhalah === "MA" || marhalah === "ma") {
      navigate(linkPage.FINAL_REPORT_CARD_MA, { state: data });
    }
  };

  useEffect(() => {
    setAppBar({ title: "Rapor", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Rapor",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-xs tw-mb-1">Filter Tahun Ajaran</div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Tahun Ajaran"
              value={tahunAjaran}
              style={{ width: "100%" }}
              onChange={(e) => {
                setTahunAjaran(e);
              }}
              options={getTahunAjaranOptions()}
              disabled={isPending || isFetching}
            ></Select>

            <div className="tw-text-xs tw-mb-1 tw-mt-3">
              Filter Data Semester
            </div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Jumlah Ditampilkan"
              value={semester}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => {
                setSemester(e);
              }}
              options={[
                { value: "1", label: "1" },
                { value: "2", label: "2" },
              ]}
              disabled={isPending || isFetching}
            ></Select>
            <p className="tw-mt-3 tw-text-sm">
              Data yang ditampilkan Semester {semester}, Tahun Ajaran{" "}
              {tahunAjaran.replace("_", "/")}
            </p>
          </div>

          <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
            {isPending || isFetching ? (
              <div className="tw-text-center">
                <Spiner />
              </div>
            ) : data?.message === "hidden" ? (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Rapor belum bisa ditampilkan</div>
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <div>
                {data.data.map((item: any, idx: number) => (
                  <div
                    key={idx}
                    className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-1 tw-mb-0.5"
                    onClick={() => onOpenDetail(item, item.marhalah)}
                  >
                    <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium tw-text-other-600 tw-w-[40%]">
                        Total Poin
                      </div>
                      <div className="tw-text-xs tw-text-center tw-font-medium tw-text-other-600 tw-w-[30%]">
                        Total Mapel
                      </div>
                      <div className="tw-text-xs tw-text-right tw-font-medium tw-text-other-600 tw-w-[40%]">
                        Rata-Rata
                      </div>
                    </div>
                    <div className="tw-px-2 tw-flex tw-justify-between tw-items-start tw-font-semibold">
                      <div className="tw-text-sm tw-w-[40%]">
                        {item.totalNilai ?? "0"}
                      </div>
                      <div className="tw-text-sm tw-text-center tw-w-[30%]">
                        {item.totalMapel ?? "0"}
                      </div>
                      <div className="tw-text-sm tw-text-right tw-w-[40%]">
                        {item.rataNilai ?? "0"}
                      </div>
                    </div>
                    <div className="tw-px-2 tw-mt-1 tw-text-[0.6rem] tw-italic tw-text-right">
                      klik untuk detail rapor
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};
